import React from "react";
import CountUp from "react-countup";
import { InView } from "react-intersection-observer";
import {
    FaCheckCircle,
    FaUsers,
    FaLightbulb,
    FaCloud,
} from "react-icons/fa";

const funFactContent = [
    {
        countStart: 0,
        countEnd: 50,
        title: "Proyectos Exitosos",
        suffix: "+",
        icon: <FaCheckCircle />,
        delayAnimation: "",
    },
    {
        countStart: 0,
        countEnd: 40,
        title: "Clientes Activos",
        suffix: "+",
        icon: <FaUsers />,
        delayAnimation: "100",
    },
    {
        countStart: 0,
        countEnd: 200,
        title: "Soluciones Técnicas",
        suffix: "+",
        icon: <FaLightbulb />,
        delayAnimation: "200",
    },
    {
        countStart: 0,
        countEnd: 100,
        title: "Infraestructura Cloud",
        suffix: "%",
        icon: <FaCloud />,
        delayAnimation: "300",
    },
];

const FunFacts = () => {
    const [focus, setFocus] = React.useState(false);
    return (
        <>
            <div className="row justify-content-center">
                {funFactContent.map((val, i) => (
                    <div
                        className="col-6 col-md-3 m-15px-tb"
                        key={i}
                        data-aos="fade-up"
                        data-aos-duration="1200"
                        data-aos-delay={i * 150}
                    >
                        <div className="feature-box-03">
                            <div className="icon" style={{ color: "#4285F4" }}>
                                {val.icon}
                            </div>
                            <div className="feature-content">
                                <div className="count-inner">
                                    <CountUp
                                        start={val.countStart}
                                        end={focus ? val.countEnd : val.countStart}
                                        duration={5.5}
                                        redraw={true}
                                    >
                                        {({ countUpRef }) => (
                                            <InView
                                                as="span"
                                                onChange={(isVisible) => {
                                                    if (isVisible) {
                                                        setFocus(true);
                                                    }
                                                }}
                                            >
                                                <span ref={countUpRef} />
                                            </InView>
                                        )}
                                    </CountUp>
                                    {val.suffix}
                                </div>
                                <h3 className="h6">{val.title}</h3>
                                {val.description && <p>{val.description}</p>}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default FunFacts;
